export default "__VITE_ASSET__DPJeqZ6D__"